import * as appState from './index';
import { AppActions, ApplictionsTypes } from './app.actions';
import { GC_AUTH_TOKEN } from '../constants';

const initialState: appState.State = {
  user: null,
  userLoading: false,
  userError: '',
  isAuthenticated: !!localStorage.getItem(GC_AUTH_TOKEN),
  showPassword: false,
  notificationCount: {
    notifications: 0,
    messages: 0,
    __typename: ''
  }
};

export function appReducer(
  state = initialState,
  action: AppActions
): appState.State {
  switch (action.type) {
    case ApplictionsTypes.LoadUser:
      return {
        ...state,
        userLoading: true,
        user: null,
        userError: ''
      };

    case ApplictionsTypes.LoadUserSuccess:
      return {
        ...state,
        userLoading: false,
        userError: '',
        user: action.payload
      };

    case ApplictionsTypes.RefreshLiveUser:
      return {
        ...state,
        userLoading: true,
        user: null,
        userError: ''
      };

    case ApplictionsTypes.LoadUserError:
      return {
        ...state,
        userLoading: false,
        user: null,
        userError: action.payload
      };

    case ApplictionsTypes.Authenticate:
      return {
        ...state,
        isAuthenticated: action.payload
      };

    case ApplictionsTypes.ClearSessionLogin:
      return {
        ...state,
        user: null,
        userError: '',
        isAuthenticated: false
      };

    case ApplictionsTypes.LoadNotificationSuccess:
      return {
        ...state,
        notificationCount: {
          ...state.notificationCount,
          messages: action?.payload?.messages,
          notifications: action?.payload?.notifications
        }
      };

    case ApplictionsTypes.IncrementMessageNotification:
      return {
        ...state,
        notificationCount: {
          ...state.notificationCount,
          messages: state.notificationCount.messages + 1
        }
      };

    case ApplictionsTypes.IncrementNormalNotification:
      return {
        ...state,
        notificationCount: {
          ...state.notificationCount,
          notifications: state.notificationCount.notifications + 1
        }
      };

    case ApplictionsTypes.DecrementNormalNotification:
      const noti =
        state.notificationCount?.notifications > 0
          ? state.notificationCount?.notifications - 1
          : 0;
      return {
        ...state,
        notificationCount: {
          ...state.notificationCount,
          notifications: noti
        }
      };

    case ApplictionsTypes.ShowPassword:
      return {
        ...state,
        showPassword: true
      };

    case ApplictionsTypes.HidePassword:
      return {
        ...state,
        showPassword: false
      };

    default:
      return state;
  }
}
